import { Navigate } from "react-router-dom";
import { isAdmin } from "../utils/AuthSession"

export default function AdminPage(props) {
    if (isAdmin()) {
        return (<>{props.children}</>)
    } else {
        return (<Navigate to='/' />);
    }
}